import { render, staticRenderFns } from "./AddNewControlInList.vue?vue&type=template&id=e5e2ccdc"
import script from "./AddNewControlInList.vue?vue&type=script&lang=js"
export * from "./AddNewControlInList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports